export const ORDER_ENDPOINT = {
  INVOICE: 'invoice',
  DOWNLOAD: 'download',
  INVOICE_HISTORY: 'invoiceHistoryByOrderId',
  CHECKOUT: 'checkout',
  ADDRESS_CHECKOUT: 'addressCheckout',
  INITIATE_ORDER_PROCESS: 'initiate/order/process',
  PRODUCT_CART: 'productCart'
};
